import { createGlobalStyle } from 'styled-components';
import { textSmall } from 'styles-js/mixins/typography';

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${props => props.theme.fontFamilyMain};
    font-size: 17px;
    line-height: 21px;
    color: ${props => props.theme.colorBlack};
  }

  small {
    ${textSmall};
  }

  strong {
    font-weight: ${({theme}) => theme.fontWeightBold};
  }

  img:not([src]) {
    visibility: hidden;
  }

  .content-top-margin {
    margin-top: 50px;
  }
`;

export default GlobalStyle;
